import { SettingsCache } from "../cache/SettingsCache";
import { FormFieldComponentProps } from "../components/new_form/form_fields/FormFieldComponent";
import { getSession } from "../helper";
import { LIST_LIFE_DOMAINS } from "../life_domain/routes";
import {
  LIST_ELEMENTS_FOR_DROPDOWNS,
  LIST_ORGANIZATIONS,
  LIST_PEOPLE,
} from "../routes/queries";

export function getNewWaitingForFormFields(): FormFieldComponentProps[] {
  return [
    {
      type: "text",
      label: "Name",
      required: true,
      key: "name",
      placeholder: "Name",
    },
    {
      type: "hardcoded",
      key: "priority",
      value: SettingsCache.getInstance().getDefaultPriority(),
    },
    {
      type: "hardcoded",
      key: "type",
      value: 2,
    },
    {
      type: "query_dropdown",
      required: false,
      label: "Life Domain",
      noSelectionLabel: "No Life Domain",
      key: "lifeDomainId",
      apiCall: {
        documentNode: LIST_LIFE_DOMAINS,
        key: "listLifeDomains",
      },
      apiVariables: {
        session: getSession(),
      },
    },
    {
      type: "query_dropdown",
      required: false,
      label: "Parent Project",
      noSelectionLabel: "No Parent Project",
      key: "parentElementId",
      apiCall: LIST_ELEMENTS_FOR_DROPDOWNS,
      apiVariables: {
        session: getSession(),
        types: [4],
      },
    },
    {
      type: "query_dropdown",
      required: false,
      label: "Organization",
      noSelectionLabel: "No Organization",
      key: "organizationId",
      apiCall: {
        documentNode: LIST_ORGANIZATIONS,
        key: "listOrganizations",
      },
      apiVariables: {
        session: getSession(),
      },
    },
    {
      type: "query_dropdown",
      required: false,
      label: "Person",
      noSelectionLabel: "No Person",
      key: "personId",
      apiCall: {
        documentNode: LIST_PEOPLE,
        key: "listPeople",
      },
      apiVariables: {
        session: getSession(),
      },
    },
    {
      type: "multiple_selection_query_dropdown",
      required: false,
      label: "Blocked By",
      key: "blockedByIds",
      itemName: "Elements",
      apiCall: LIST_ELEMENTS_FOR_DROPDOWNS,
      apiVariables: {
        session: getSession(),
        types: [1, 2, 3, 4, 5],
      },
    },
    {
      type: "multiple_selection_query_dropdown",
      required: false,
      label: "Blocks",
      key: "blocksIds",
      itemName: "Elements",
      apiCall: LIST_ELEMENTS_FOR_DROPDOWNS,
      apiVariables: {
        session: getSession(),
        types: [1, 2, 3, 4, 5],
      },
    },
  ];
}
